import { render } from "./SupplierAgingReport.vue?vue&type=template&id=5686075f&scoped=true"
import script from "./SupplierAgingReport.vue?vue&type=script&lang=js"
export * from "./SupplierAgingReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=5686075f&scoped=true&lang=css&external"
import "./SupplierAgingReport.vue?vue&type=style&index=1&id=5686075f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5686075f"]])

export default __exports__